/* global React, Field, Input, Select, Checkbox, Currency */
// Shared travel form from the Plumme design export.
const TRIP_COUNTRIES = ['Norge', 'Sverige', 'Danmark', 'Finland', 'Tyskland', 'Storbritannia', 'USA', 'Annet'];

function tripFormDefaults(extra) {
  return Object.assign({
    diet: 'no',
    overnight: 'no',
    employee: '',
    date: '',
    dateFrom: '',
    dateTo: '',
    timeFrom: '',
    timeTo: '',
    purpose: '',
    country: 'Norge',
    meals: { frokost: false, lunsj: false, middag: false },
  }, extra || {});
}

function tripFormValid(v) {
  return !!(v.purpose && v.purpose.trim());
}

function tripDates(v) {
  const single = v.diet === 'yes' && v.overnight !== 'yes';
  return single ? { dateFrom: v.date, dateTo: v.date } : { dateFrom: v.dateFrom, dateTo: v.dateTo };
}

function TripRadioRow({ ns, field, value, options, onChange }) {
  return <div className="cl-radio-group">
    {options.map(([val, label]) => <label key={val} className={'cl-radio' + (value === val ? ' on' : '')}>
      <input type="radio" name={ns + '_' + field} checked={value === val} onChange={() => onChange(val)} />
      <span className="cl-radio-dot" /><span className="cl-radio-lbl">{label}</span>
    </label>)}
  </div>;
}

function TravelTripFields({ v, set, showEmployee, employees, ns = 'trip' }) {
  const diett = v.diet === 'yes';
  const overnight = v.overnight === 'yes';
  const dayTrip = diett && !overnight;
  const splitDates = !diett || overnight;
  const meals = v.meals || {};
  const setMeal = (key, checked) => set('meals', Object.assign({}, meals, { [key]: checked }));

  return <React.Fragment>
    <Field label={t('tf.subsistenceQuestion')} help={t('helpTopics.subsistence.body')} helpTitle={t('helpTopics.subsistence.title')}>
      <TripRadioRow ns={ns} field="diet" value={v.diet} onChange={(val) => set('diet', val)}
        options={[['no', 'Nei, kun utlegg og kjøring'], ['yes', 'Ja, bruk diett']]} />
    </Field>

    {diett && <Field label={t('tf.accommodationQuestion')} help={t('helpTopics.subsistence.body')} helpTitle={t('helpTopics.subsistence.title')}>
      <TripRadioRow ns={ns} field="overnight" value={v.overnight} onChange={(val) => set('overnight', val)}
        options={[['no', 'Nei, dagstur'], ['yes', 'Ja, reise med overnatting']]} />
    </Field>}

    {showEmployee && <Field label={t('shell.client.employee')}>
      <Select value={v.employee || ''} onChange={(e) => set('employee', e.target.value)}>
        <option value="">{t('tf.pickEmployee')}</option>
        {(employees || []).map((employee) => <option key={employee.id || employee.name} value={employee.name}>{employee.name}</option>)}
      </Select>
    </Field>}

    {splitDates
      ? <div className="grid-2 gap-14">
          <Field label={t('pay.dateFrom')}><Input type="date" value={v.dateFrom || ''} onChange={(e) => set('dateFrom', e.target.value)} /></Field>
          <Field label={t('pay.dateTo')}><Input type="date" value={v.dateTo || ''} onChange={(e) => set('dateTo', e.target.value)} /></Field>
        </div>
      : <Field label={t('cust.ledger.date')}><Input type="date" value={v.date || ''} onChange={(e) => set('date', e.target.value)} /></Field>}

    {diett && <div className="grid-2 gap-14">
      <Field label={t('tf.timeFrom')}><Input type="time" value={v.timeFrom || ''} onChange={(e) => set('timeFrom', e.target.value)} /></Field>
      <Field label={t('tf.timeTo')}><Input type="time" value={v.timeTo || ''} onChange={(e) => set('timeTo', e.target.value)} /></Field>
    </div>}

    <Field label={t('pay.purposeHelp')} help={t('helpTopics.tripPurpose.body')} helpTitle={t('helpTopics.tripPurpose.title')}>
      <textarea className="input ans-trip-purpose" rows={2} value={v.purpose || ''} onChange={(e) => set('purpose', e.target.value)} placeholder={t('pay.purposePh')} />
    </Field>

    <Field label={t('pay.whereDidYouGo')} help={t('helpTopics.tripPurpose.body')} helpTitle={t('helpTopics.tripPurpose.title')}>
      <Select value={v.country || 'Norge'} onChange={(e) => set('country', e.target.value)}>
        {TRIP_COUNTRIES.map((country) => <option key={country}>{country}</option>)}
      </Select>
    </Field>

    {dayTrip && <Field label={t('tf.mealsCovered')} hint="Marker måltider som var dekket av arbeidsgiver, arrangør eller vertskap.">
      <div className="ans-meals">
        {[['frokost', 'Frokost'], ['lunsj', 'Lunsj'], ['middag', 'Middag']].map(([key, label]) =>
          <Checkbox key={key} checked={!!meals[key]} onChange={(checked) => setMeal(key, checked)}>{label}</Checkbox>)}
      </div>
    </Field>}
  </React.Fragment>;
}

// NOK amount actually paid for an expense in foreign currency (card statement or
// bank). Payroll reimburses this amount; a foreign line without it is not paid.
function ForeignAmountNokField({ currency, amount, value, onChange }) {
  const code = String(currency || 'NOK').toUpperCase();
  if (code === 'NOK') return null;
  const original = window.PlummeMoneyInput.parse(amount, { preferDecimal: true }) || 0;
  const nok = window.PlummeMoneyInput.parse(value, { preferDecimal: true }) || 0;
  const rate = original > 0 && nok > 0 ? (nok / original).toFixed(4) : '';
  return <Field label={t('pay.foreignAmount.label')} hint={rate ? t('pay.foreignAmount.rateHint', { rate, currency: code }) : t('pay.foreignAmount.hint', { currency: code })}>
    <Currency value={value} onChange={(event) => onChange(event.target.value)} placeholder="0" />
  </Field>;
}

Object.assign(window, { TravelTripFields, tripFormDefaults, tripFormValid, tripDates, ForeignAmountNokField });
